











import { Vue, Component, Prop } from 'vue-property-decorator'
import type { CardDeMetrica as MetricaParaExibir } from '@/shareds/painel-do-cliente-shareds'

@Component
export default class CardDeMetrica extends Vue {
	@Prop({ type: Object, required: true }) card!: MetricaParaExibir
}
